import TextCard from './TextCard';
import { TextCardProps, TextCardValueProps } from './types';

export type { TextCardProps, TextCardValueProps };
export default TextCard;
